<template>
    <el-menu
        :class="{ 'cus-menu-v': mode == 'vertical', 'cus-menu-h': mode == 'horizontal' }"
        @select="handleSelect"
        :default-active="activeMenu"
        :mode="mode"
        :router="router"
        :unique-opened="true"
        :collapse="collapse"
    >
        <template v-for="(item, index) in menu">
            <el-submenu :index="item.index" v-if="item.children && item.children.length > 0" :key="index" v-has-permission="item.permission">
                <template slot="title">
                    <text-formatter type="icons" v-if="item.icon" v-model="item.icon" class="width20"></text-formatter>
                    <span slot="title">{{ item.label }}</span>
                </template>
                <template v-for="c in item.children">
                    <TreeMenuItem :item="c" :key="c.index"></TreeMenuItem>
                </template>
            </el-submenu>
            <el-menu-item v-else v-has-permission="item.permission" :key="item.index" :index="item.index" :route="item.route">
                <text-formatter type="icons" v-if="item.icon" v-model="item.icon" class="width20"></text-formatter>
                <span class="menu-item-content" slot="title">
                    {{ item.label }}
                </span>
            </el-menu-item>
        </template>
    </el-menu>
</template>

<script>
import TreeMenuItem from './TreeMenuItem.vue'
export default {
    name: `TreeMenu`,
    components: {
        TreeMenuItem
    },
    props: {
        data: { type: Array, required: true },
        mode: {
            type: String,
            validator: function(t) {
                return t === `horizontal` || t === `vertical`
            },
            default: `vertical`
        },
        router: { type: Boolean, default: true },
        collapse: {
            type: Boolean, default: false
        }
    },
    data() {
        return {
            activeMenu: ``,
            selectKey: ``
        }
    },
    mounted() {
        this._activeMenu()
    },
    computed: {
        menu() {
            return this.data
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            let r = this.data.find(d => d.index == key)
            console.log(`select`, r)
            if (r && r.is_eject && r.is_eject == 1) {
                console.log(r.path)
                let oldurl = r.path
                let url = oldurl
                let query = r.route.query
                console.log(query)
                let querystring = ``
                _.each(query, (value, key) => {
                    querystring += key + `=` + value + `&`
                })
                if (querystring != ``) {
                    let sourceindex = oldurl.indexOf(`source`)
                    if (sourceindex != -1) {
                        let lefturl = oldurl.substring(0, sourceindex)
                        let righturl = oldurl.substring(sourceindex, oldurl.length)
                        url = lefturl + `&isOnlyShowMain=true&workbar=1111&isOnlyShowMe=1&` + querystring + righturl
                    } else {
                        url += url.indexOf(`?`) > -1 ? `&` : `?`
                        url += querystring + `isOnlyShowMain=true&workbar=1111&isOnlyShowMe=1&`
                    }
                }
                let routeUrl = this.$router.resolve({
                    path: url
                })
                window.open(routeUrl.href)
                // window.open(`#/9/surgeryinfo?surgery_id=4621&rdate=2024%2F02%2F26&isOnlyShowMain=true&workbar=9&record_type=1`)
            } else {
                this.selectKey = key
                this.$emit(`select`, key, keyPath)
                this._activeMenu()
            }
        },
        _activeMenu() {
            let that = this
            let r = this.data.find(d => d.index == this.selectKey)
            if (r) {
                if (that.selectKey && that.selectKey.trim() != ``) {
                    that.activeMenu = that.selectKey
                }
                that.$router.push(r.route)
            }
        }
    },
    watch: {
        // $route() {

        // }
    }
}
</script>

<style scoped>
.el-menu {
    text-align: left;
}
.cus-icon {
    width: 20px;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/common/TreeMenu.vue